module.exports = (require("./helpers/browser/js-loader")(require('./helpers/bundle-manifest').resolve("80Zxn"))).then(() => parcelRequire('37nVf'));